export function parseFixedISOStringToDate(isoString: string): Date {
  const [datePart, timePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart
    .replace("Z", "")
    .split(":")
    .map(Number);
  return new Date(year, month - 1, day, hour, minute, second || 0);
}

export function toFixedISOString(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}.000Z`;
}

// Ay adlarını Türkçe olarak yaz
const turkishMonths = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

// Date objesinden Türkçe tarih üretir: 1 Ocak 2025
export function formatDateToTurkishString(date: Date): string {
  const day = date.getDate();
  const month = turkishMonths[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

// ISO string alır, Date'e çevirip yukarıdaki fonksiyonla işler
export function formatISOToTurkishString(isoString: string): string {
  const date = parseFixedISOStringToDate(isoString);
  return formatDateToTurkishString(date);
}
export function formatISOToTurkishStringPlus2(isoString: string): string {
  const date = parseFixedISOStringToDate(isoString);
  date.setDate(date.getDate() + 2);
  return formatDateToTurkishString(date);
}
